import React from "react";

export interface StepDef {
    title: string;
    hint?: string;
}

export const STEPS: StepDef[] = [
    { title: "Facebook login", hint: "You allow Empedance to manage WhatsApp for your business" },
    { title: "WhatsApp account shared" },
    { title: "Phone number chosen" },
    { title: "Messages routed to Empedance", hint: "Incoming chats and delivery updates reach your inbox" },
    { title: "Billing by Empedance", hint: "Meta bills Empedance; you pay from your wallet" },
    { title: "Number registered on WhatsApp", hint: "Secured with a two-step PIN" },
    { title: "Live", hint: "Ready for templates, broadcasts and chat" },
];

interface Props {
    current: number;     // 1-based active step; 8 = everything done
    failed?: boolean;
    details?: Record<number, string | undefined>; // e.g. {2: "Acme Retail", 3: "+91 ..."}
}

const Check = () => (
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
        <path d="M2.5 6.5l2.5 2.5 4.5-5.5" stroke="#fff" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

export default function Stepper({ current, failed, details = {} }: Props) {
    return (
        <ol className="isolate flex flex-col">
            {STEPS.map((s, i) => {
                const n = i + 1;
                const done = n < current;
                const active = n === current;
                const err = active && failed;
                const circle = done
                    ? "bg-[#0f7b5a] border-[#0f7b5a] text-white"
                    : err
                        ? "bg-white border-red-600 text-red-600"
                        : active
                            ? "bg-[#fdf1dc] border-amber-600 text-amber-800"
                            : "bg-white border-gray-300 text-gray-600";
                const text = details[n] || s.hint;
                return (
                    <li key={s.title} className="relative flex gap-3 pb-5 last:pb-0">
                        {n < STEPS.length && (
                            <span
                                className={`absolute left-[13px] top-7 h-[calc(100%-28px)] w-0.5 ${done ? "bg-[#0f7b5a]" : "bg-gray-200"
                                    }`}
                            />
                        )}
                        <span
                            className={`z-10 flex h-7 w-7 shrink-0 items-center justify-center rounded-full border-2 text-xs font-semibold ${circle}`}
                        >
                            {done ? <Check /> : n}
                        </span>
                        <div className="pt-0.5">
                            <div
                                className={`text-sm ${err ? "font-semibold text-red-600" : done || active ? "font-semibold text-[#10231d]" : "text-gray-600"
                                    }`}
                            >
                                {s.title}
                            </div>
                            {text && <div className="mt-0.5 text-xs text-gray-500">{text}</div>}
                        </div>
                    </li>
                );
            })}
        </ol>
    );
}